/**
 * Zen's tokens
 * @see https://www.figma.com/file/KtZazS0WohJIuWYdqXgn1Y/Zen---Design-system-(Harmony)?type=design&node-id=3417-2113&mode=design&t=sK4i9kzvc51In64e-0
 */ import { primaryPaletteNumbered } from "./foundations/colors";
import { semanticTokens } from "./semantic-tokens";
export const getZenExtension = (options = {
    fontFamilyHeading: 'Epilogue'
})=>{
    return [
        {
            semanticTokens: semanticTokens,
            colors: {
                primary: primaryPaletteNumbered
            },
            fonts: {
                heading: `${options.fontFamilyHeading}, Arial, sans-serif`
            }
        }
    ];
};

//# sourceMappingURL=index.js.map